import React, {Component} from "react"
import {connect} from "react-redux"
import {injectIntl} from 'react-intl'
import {Button, Modal} from "react-bootstrap"
import {alertSuccess} from "../../../util/AlertUtil"
import {queryUserInfoById, enterpriseUserAdd, updateUserInfoById} from "../../../dispatch"
import {EVENT_USER_CREATED, EVENT_USER_UPDATED, PATH_USER_IMAGE_UPLOAD_BY_ID} from "../../../constants"
import IBoxRow from "../../../components/IBoxRow"
import UserForm from "../../../components/UserForm"
import {handleRadioGroupValue} from "../../../util/FormUtil"
import Alert from "../../../components/Alert"
import ErrorAlert from "../../../components/ErrorAlert"
import Spinner from "../../../components/Spinner"
import ImageUploadModal from "../../../components/ImageUploadModal"
import UserImage from "../../../components/UserImage"

import { RxEmitter } from 'rxemitter';

function mapStateToProps(state, ownProps) {

  const selectedUser = state.selectedUser
  const user = state.user

  return {
    selectedUser, user
  }
}

const mapDispatchToProps = {
  queryUserInfoById,
  enterpriseUserAdd,
  updateUserInfoById
}

class UserFormModal extends Component {

  constructor() {
    super()
    this.state = {
      submitted: false,
      uploadImageModalOpen: false
    }

  }

  submitForm = (data) => {


    delete data.repassword
    if (data.password === "") delete data.password
    data.accountLocked = handleRadioGroupValue(data.accountLocked)
    data.isMale = handleRadioGroupValue(data.isMale)

    data.ownerEnterpriseAccountId = op.get(this.props.user, 'currentEnterpriseAccount.id')

    data = _.pickBy(data, (it) => !_.isNil(it) && it !== '')

    if (this.props.id) {
      data.id = this.props.id
      this.props.updateUserInfoById(data)
    } else {
      this.props.enterpriseUserAdd(data)
    }
  }

  componentWillMount() {

    const format = this.props.intl.formatMessage

    RxEmitter.on(EVENT_USER_CREATED).subscribe((x)=> {
      alertSuccess(format({id:'user.created'}), "", ()=>{this.props.onHide(true)})

    });

    RxEmitter.on(EVENT_USER_UPDATED).subscribe((x)=> {
      alertSuccess(format({id:'user.updated'}), "", ()=>{this.props.onHide(true)})
    });

    if (this.props.id)
      this.props.queryUserInfoById(this.props.id)
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.id !== this.props.id)
      this.props.queryUserInfoById(nextProps.id)

  }

  saveUser = ()=>{
    this.setState({submitted: true})
    const userForm = this.form
    if(userForm) userForm.submit()
  }

  openImageModal = () => {
    this.setState({uploadImageModalOpen: true})
  }
  closeImageModal = () => {
    this.setState({uploadImageModalOpen: false})
  }

  enableSubmitButton = () => {
    this.setState({
      disabled: false
    });
  }

  disableSubmitButton = () => {
    this.setState({
      disabled: true
    });
  }

  render() {

    const userId = this.props.id
    const format = this.props.intl.formatMessage
    const user = userId || this.state.submitted?this.props.selectedUser:(this.props.defaultData || {})


    const config = {
      emailAddress: {
        readOnly: this.props.id || op.get(this.props.defaultData, 'emailAddress')?true:false,
        required: true
      },
      password: {
        required: this.props.id?false:true
      },
      accountLocked: {
        hidden: true
      },
      enterpriseReference:{
        hidden: false
      },
      submit:{
        hidden: true
      }
    }

    return (
      <Modal bsSize="lg"
             onEntered={()=>{
               user.message = null
               this.setState({submitted: false})
             }}
             show={this.props.show} onHide={()=>{this.props.onHide(false)}}>

        <Modal.Header closeButton>
          <h2>{this.props.title || this.props.id?format({id:'edit.user'}, {id:this.props.id}):format({id:'add.user'})}</h2>
        </Modal.Header>

        <Modal.Body className="gray-bg" style={{height:480}}>

          <IBoxRow>
            <div className="row">
              <div className="col-xs-10">
                <UserForm user={user}
                          onValid={this.enableSubmitButton}
                          onInvalid={this.disableSubmitButton}
                          config={config}
                          onSubmit={this.submitForm}
                          onRef={(form)=>{this.form = form}}
                          />
              </div>
              <div className="col-xs-2 text-center">

              </div>
            </div>


          </IBoxRow>

        </Modal.Body>

        <Modal.Footer>
          <Spinner show={user.loading}/>
          <ErrorAlert error={user.error}/>
          <Alert show={user.message} message={user.message ? user.message : ""} level="info"/>
          <Button onClick={()=>{this.props.onHide(false)}}>
            {format({id:'cancel'})}
          </Button>
          <div className={`btn btn-primary ${user.loading || this.state.disabled?'disabled':''}`} onClick={this.saveUser}>
            {format({id:'save'})}
          </div>

        </Modal.Footer>
      </Modal>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UserFormModal))



// WEBPACK FOOTER //
// ./src/routes/enterprise/components/UserFormModal.js